// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/CRMDashboardNavigator.jsx
// Purpose:
// CRM Dashboard Navigation Tabs
// ======================================================================

import React from "react";
import { NavLink } from "react-router-dom";

export default function CRMDashboardNavigator() {
const tabs = [
  {
    label: "Executive",
    route: "/ipe/dashboard/crm/executive",
    icon: "fas fa-tachometer-alt",
  },
  {
    label: "Operations",
    route: "/ipe/dashboard/crm/operations",
    icon: "fas fa-tasks",
  },
  {
    label: "Analytics",
    route: "/ipe/dashboard/crm/analytics",
    icon: "fas fa-chart-line",
  },
  {
    label: "Reports",
    route: "/ipe/dashboard/crm/reports",
    icon: "fas fa-file-alt",
  },
];

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "10px",
        marginBottom: "20px",
        border: "1px solid #e5e7eb",
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.route}
          to={tab.route}
          style={({ isActive }) => ({
            textDecoration: "none",
            padding: "10px 16px",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: isActive
              ? "#2563eb"
              : "#f8fafc",
            color: isActive
              ? "#fff"
              : "#334155",
            border: isActive
              ? "1px solid #2563eb"
              : "1px solid #e5e7eb",
            transition: "all .2s ease",
          })}
        >
          <i className={tab.icon}></i>
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}